const validationTypes = {
  not_blank: (value, translatable, languages) => {
    const validation = v => v && v.length > 0
    if (translatable) {
      let valid = true
      Object.keys(languages).forEach(language => {
        if (!validation(value[language])) {
          valid = false
        }
      })
      return valid
    }
    return validation(value)
  },
  password: (value, translatable, languages, extraData) => {
    if (extraData.mode === 'edit') return true
    return value && value.length > 5 && value === extraData.repeated
  },
}

const Errors = (value, validations, translatable, languages, extraData = {}) => {
  const valid = []
  if (validations) {
    Object.keys(validations).forEach(validation => {
      if (
        typeof validationTypes[validation] !== 'undefined'
        && !validationTypes[validation](value, translatable, languages, extraData)
      ) {
        valid.push(validations[validation])
      }
    })
  }
  return valid
}

export default Errors
